import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
{ question: "Can I have a site like this?", answer: "Yes, go to the forum and look for Website App for sale to find out all you need to know." },
  { question: "What if I have Questions not answered here?", answer: "Go to the Forum from the top menu" },

  { question: "Why don't the buy button work?", answer: "Everything on this Site has to be purchased by preorder." },
  { question: "Why preorder only?", answer: "Because I'm a Targeted Individual " },
 
  { question: "What is a Targeted Individual?", answer: "Ask uncle Sam, or look it up on youtube." },
  { question: "What happens if you don't get enough preorders?", answer: "I don't release for sell and move on to the next project." },
  
  { question: "What happens when a preorder is placed?", answer: "Your name, or the name you use when you confirm in the popup modal goes into a database.You will be contacted and informed that the item you chose is now available for purchase" },
  { question: "Can I put items in the cart?", answer: "Yes, you just won't be able to buy them with money yet." },
  
  { question: "Why would anybody buy a pdf art print?", answer: "Because it's ten times cheaper than buying one on canvas." },
  { question: "How do I use the pdf art print?", answer: "For complete instructions go to Forum and search the Pdf Artprint categories." },
  
  { question: "What is the difference between an 18.00 novel and a 10.00?", answer: "The higher priced novels have the soundtrack Albums embedded so you can play songs wriiten to scenes, inside the book; it's cheaper than buying the ebooks and their soundtrack albums, separately." },
  { question: "What if I want to listen to the songs outside the books", answer: "The mp3s come in a folder packaged with the ebook." },
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };


  return (
    <div className="faq-block-container">
      <section id="faq">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq ${activeIndex === index ? 'active' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              {faq.question}
            </div>
            <div className="faq-answer">
              {faq.answer}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default FAQSection;